import { isBrowser } from 'ws-scripts/modules/environment';

/**
 * Returns the global window.DDC object, or null when not in a browser context.
 * All other accessors in this module are built on top of this.
 */
const getDDC = () => {
	if (!isBrowser || typeof window === 'undefined') {
		return null;
	}
	return window.DDC ?? null;
};

/** Returns the DDC pubsub instance used for inter-widget communication. */
export const getDDCPubSub = () => getDDC()?.pubsub ?? null;

/** Returns the LocationsData instance registered on the DDC global. */
export const getDDCLocationsData = () => getDDC()?.LocationsData ?? null;

/**
 * Returns all URL params from the DDC URL parser.
 * Falls back to an empty object when the method is not available.
 */
export const getDDCUrlParams = () => getDDC()?.getUrlParams?.() ?? {};

/** Returns the DDC user location object containing postal code and coordinates. */
export const getDDCUserLocation = () => getDDC()?.userLocation ?? null;
